import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {Switch,Typography,Grid} from '@material-ui/core';
import { eliminarAreaUsuario, setAreaUsuario } from "../../../actions/usuarios/areas";
import { useDispatch } from "react-redux";
import { AREAS_USUARIOS } from "../../../utils/constants";
import { startAlerta } from "../../../actions/ui/alertas";


const useStyles = makeStyles({
    root:{
        background:'#212121'
    },
    TypographyRoot:{
        color:'white'
    },
    switchBase:{
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#4CAF50',
            '& + $track': {
              backgroundColor: '#3E8040',
              opacity: 1,
              border: 'none',
            },
          },
    },
    switchBase2:{
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#ffee58',
            '& + $track': {
              backgroundColor: '#B7A931',
              opacity: 1,
              border: 'none',
            },
          },
    },
    checked:{},
    track: {},
    swithColorPrimary:{
        color: 'yellow'
    }
});

export const Area = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {idArea, idUsuario, idSeccional, descripcionArea, seleccionado, idUsuarioArea}= props; 

  const handleChange = e => {
      if(e.target.checked){
        if(!idSeccional && idArea === AREAS_USUARIOS.CENTROS_MEDICOS){
          return dispatch( startAlerta("Para asignar el Area CENTROS MEDICOS el Usuario debe tener una Seccional", "error") );
        }
        
        dispatch( setAreaUsuario(idUsuario, idArea) );
      }else{
        dispatch( eliminarAreaUsuario(idUsuarioArea) );
      }
  }

  return (
    <>
      <Grid item xs={3} md={3}>
        <Switch 
            checked={seleccionado}
                        name={descripcionArea}
                        value={idArea}
                        onChange={handleChange}
                        classes={{switchBase:classes.switchBase,checked:classes.checked,track:classes.track}}
        />
      </Grid>
      <Grid item xs={9} md={9}>
        <Typography className={classes.TypographyRoot} >{descripcionArea}</Typography>
      </Grid>
    </>
  );
};